import React, { useState } from "react";
import { Button, Badge } from "./ui";
import { MDBContainer, MDBCard, MDBCardBody, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBInput, MDBRow, MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBRadio } from "mdb-react-ui-kit";

function Branches() {
  const [openModal, setOpenModal] = useState(false);

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const branchesData = [
    // Replace with API data
    {
      id: 1,
      name: "Branch 1",
      location: "Location 1",
      manager: "Manager 1",
      status: "Active",
    },
    {
      id: 2,
      name: "Branch 2",
      location: "Location 2",
      manager: "Manager 2",
      status: "Inactive",
    },
    // ... more branches
  ];

  return (
    <MDBContainer fluid className="p-4 content-area flex-grow-1">
      <h2>Branches</h2>
      <MDBRow className="mb-4 g-4">
        <MDBCol md="12">
          <MDBCard className="h-100">
            <MDBCardBody className="text-center">
              {branchesData.length === 0 && <p>No Branches Added</p>}
              <Button onClick={toggleModal}>Add a branch</Button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      <MDBRow>
        <MDBCol md="12">
          <MDBCard className="content-card">
            <MDBCardBody>
              <MDBTable align="middle" responsive>
                <MDBTableHead className="table-header">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Location</th>
                    <th scope="col">Manager</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className="table-row">
                  {branchesData.map((branch) => (
                    <tr key={branch.id}>
                      <td>{branch.id}</td>
                      <td>{branch.name}</td>
                      <td>{branch.location}</td>
                      <td>{branch.manager}</td>
                      <td>
                        <Badge
                          color={
                            branch.status === "Active" ? "success" : "danger"
                          }
                          pill
                        >
                          {branch.status}
                        </Badge>
                      </td>
                      <td>
                        <Button color="info" size="sm">
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </MDBTableBody>
              </MDBTable>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>

      {/* Modal for adding new branch */}
      <MDBModal open={openModal} setOpen={setOpenModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Add Branch</MDBModalTitle>
              <Button
                className="btn-close"
                color="none"
                onClick={toggleModal}
              ></Button>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBInput className="mb-4" type="text" label="Name" />
              <MDBInput className="mb-4" type="text" label="Location" />
              <MDBInput className="mb-4" type="text" label="Manager" />
              <div className="mb-4">
                <label>Is the branch active?</label>
                <MDBRadio name="isActive" id="active" label="Yes" />
                <MDBRadio name="isActive" id="inactive" label="No" />
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <Button color="secondary" onClick={toggleModal}>
                Close
              </Button>
              <Button>Submit</Button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  );
}

export default Branches;
